module.exports = __webpack_public_path__ + "static/media/search.e7f10280.svg";